import React from "react";
import SectionMessage from "@atlaskit/section-message";
var PremiseDisabledEnv = ["stg-eucentral2"];
export var PremiseDisabledSectionMessage = function (_a) {
    var environment = _a.environment;
    return (React.createElement(SectionMessage, { title: "Premise setup is disabled", appearance: "error" },
        "Premise setup is not supported on services deployed in the ",
        environment,
        " ",
        "environment."));
};
export var IsPremiseDisabled = function (environment) {
    return PremiseDisabledEnv.includes(environment);
};
